import { setCssVar } from 'quasar'
import { empty } from 'src/utils/variables.js'

const aptcLayout = {
  logo: 'logo-aptc-dark-BG.png',
  name: 'aptc',
  bgClass: 'bg-aptc',
  colorPrimary: '#1976D2',
  colorSecondary: '#83b326'
}
const layouts = {
  aptelecare: aptcLayout,
  healabs: {
    logo: 'healabs-logo.png',
    name: 'healabs',
    bgClass: 'bg-healabs',
    colorPrimary: '#13354D',
    colorSecondary: '#1AB872'
  },
  esantelys: {
    ...aptcLayout,
    logo: 'https://cdn.healabs.fr/themes/santelys/logo-blanc.png'
  }
}

export function getPlatformLayout(branding) {
  let layout
  if (!empty(branding) && Object.hasOwn(layouts, branding)) {
    layout = layouts[branding]
  } else {
    layout = layouts[window.location.href.includes('aptelecare') ? 'aptelecare' : 'healabs']
  }

  layout.logo = layout.logo.startsWith('http')
    ? layout.logo
    : new URL(`/src/assets/${layout.logo}`, import.meta.url).href

  setCssVar('primary', layout.colorPrimary)
  setCssVar('secondary', layout.colorSecondary)

  return layout
}
